/**
 * Werk winkelwagenpagina-prijzen bij vanuit /cart.js (zonder cart drawer).
 */
(function () {
  'use strict';

  function moneyFormat() {
    var cfg = window.UF_CART_PROMO_CONFIG || {};
    return cfg.moneyFormat || (window.Shopify && window.theme && window.theme.moneyFormat) || undefined;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat());
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function unitStackHtml(item, lineIdx) {
    var row = document.querySelector('.uf-cart-page__line[data-line="' + lineIdx + '"]');
    if (!row) return '';
    var cmpAt = parseInt(row.getAttribute('data-uf-compare-at'), 10) || 0;
    var unitOrig = parseInt(row.getAttribute('data-uf-unit-orig'), 10) || 0;
    var unitFinal = typeof item.final_price === 'number' ? item.final_price : item.price;
    var parts = [];
    if (cmpAt > unitOrig) {
      parts.push(
        '<span class="uf-price-stack__tier uf-price-stack__compare"><s class="uf-strike uf-strike--blue">' +
          formatMoney(cmpAt) +
          '</s></span>'
      );
    }
    if (unitFinal < unitOrig) {
      parts.push(
        '<span class="uf-price-stack__tier uf-price-stack__precode"><s class="uf-strike uf-strike--green">' +
          formatMoney(unitOrig) +
          '</s></span>'
      );
    }
    parts.push(
      '<span class="uf-price-stack__tier uf-price-stack__final"><span class="money">' +
        formatMoney(unitFinal) +
        '</span></span>'
    );
    return '<div class="uf-cart-page__unit-stack uf-price-stack">' + parts.join('') + '</div>';
  }

  function lineTotalStackHtml(item, lineIdx) {
    var row = document.querySelector('.uf-cart-page__line[data-line="' + lineIdx + '"]');
    if (!row) return '';
    var cmpAt = parseInt(row.getAttribute('data-uf-compare-at'), 10) || 0;
    var unitOrig = parseInt(row.getAttribute('data-uf-unit-orig'), 10) || 0;
    var q = item.quantity;
    var finalLine = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
    var origLine = item.original_line_price;
    var parts = [];
    if (cmpAt > unitOrig) {
      parts.push(
        '<span class="uf-price-stack__tier uf-price-stack__compare"><s class="uf-strike uf-strike--blue">' +
          formatMoney(cmpAt * q) +
          '</s></span>'
      );
    }
    if (origLine > finalLine) {
      parts.push(
        '<span class="uf-price-stack__tier uf-price-stack__precode"><s class="uf-strike uf-strike--green">' +
          formatMoney(origLine) +
          '</s></span>'
      );
    }
    parts.push(
      '<span class="uf-price-stack__tier uf-price-stack__final amount price-' +
        lineIdx +
        '"><span class="money">' +
        formatMoney(finalLine) +
        '</span></span>'
    );
    return (
      '<div class="uf-cart-page__line-total-wrap uf-price-stack" data-line="' + lineIdx + '">' + parts.join('') + '</div>'
    );
  }

  function compareByVariantFromPage(cart) {
    var map = {};
    if (!cart || !cart.items) return map;
    cart.items.forEach(function (item, i) {
      var row = document.querySelector('.uf-cart-page__line[data-line="' + i + '"]');
      var cmpAt = row ? parseInt(row.getAttribute('data-uf-compare-at'), 10) || 0 : 0;
      if (item.variant_id) map[item.variant_id] = cmpAt;
    });
    return map;
  }

  function grandCompareTotalCents(cart) {
    if (typeof window.ufCartGrossCents === 'function') {
      return window.ufCartGrossCents(cart, compareByVariantFromPage(cart));
    }
    var sum = 0;
    if (!cart || !cart.items) return 0;
    cart.items.forEach(function (item, i) {
      var row = document.querySelector('.uf-cart-page__line[data-line="' + i + '"]');
      var cmpAt = row ? parseInt(row.getAttribute('data-uf-compare-at'), 10) || 0 : 0;
      var orig = typeof item.original_price === 'number' ? item.original_price : item.price;
      var unit = cmpAt > orig ? cmpAt : orig;
      sum += unit * item.quantity;
    });
    return sum;
  }

  function grandStackHtml(cart) {
    var origTot = cart.original_total_price;
    var tot = cart.total_price;
    var cmpTot = grandCompareTotalCents(cart);
    var parts = [];
    if (cmpTot > origTot) {
      parts.push(
        '<span class="uf-price-stack__tier uf-price-stack__compare"><s class="uf-strike uf-strike--blue">' +
          formatMoney(cmpTot) +
          '</s></span>'
      );
    }
    if (origTot > tot) {
      parts.push(
        '<span class="uf-price-stack__tier uf-price-stack__precode"><s class="uf-strike uf-strike--green">' +
          formatMoney(origTot) +
          '</s></span>'
      );
    }
    parts.push(
      '<span class="uf-price-stack__tier uf-price-stack__final subtotal-price"><span class="money">' +
        formatMoney(tot) +
        '</span></span>'
    );
    return parts.join('');
  }

  function updateGrandTotal(cart) {
    var stack = document.querySelector('.uf-cart-page__grand-stack');
    if (!stack || !cart) return;
    stack.innerHTML = grandStackHtml(cart);
  }

  function updateSavingsBanner(cart) {
    var panel = document.querySelector('.uf-cart-page .uf-cart-checkout-panel');
    if (!panel) return;
    var breakdown =
      typeof window.ufCartDiscountBreakdown === 'function'
        ? window.ufCartDiscountBreakdown(cart, compareByVariantFromPage(cart))
        : {
            totalSaveCents: (cart && cart.total_discount) || 0,
            productSaveCents: 0,
            actieCents: (cart && cart.total_discount) || 0,
            showActie: !!((cart && cart.total_discount) || 0),
            showTotal: false
          };
    var productSave =
      typeof breakdown.productSaveCents === 'number'
        ? breakdown.productSaveCents
        : Math.max(0, (breakdown.totalSaveCents || 0) - (breakdown.actieCents || 0));
    var section = panel.querySelector('.uf-cart-checkout-panel__section--savings');
    if (productSave <= 0) {
      if (section) section.hidden = true;
      return;
    }
    if (!section) {
      section = document.createElement('div');
      section.className = 'uf-cart-checkout-panel__section uf-cart-checkout-panel__section--savings';
      var first = panel.firstElementChild;
      panel.insertBefore(section, first);
    }
    var totalHtml =
      typeof window.ufCartTotalSaveHtml === 'function'
        ? window.ufCartTotalSaveHtml(formatMoney(productSave))
        : formatMoney(productSave) + ' product korting toegepast';
    var html = '';
    if (breakdown.showTotal !== false && productSave > 0) {
      html +=
        '<p class="uf-cart-checkout-panel__savings uf-cart-checkout-panel__savings--total">' +
        '<span class="cart-subtotal__savings"><em>' +
        totalHtml +
        '</em></span></p>';
    }
    if (!html) {
      if (section) section.hidden = true;
      return;
    }
    section.hidden = false;
    section.innerHTML = html;
  }

  function ufCartPageUpdatePrices(cart) {
    if (!cart || !document.querySelector('.uf-cart-page')) return false;
    if (!cart.items || !cart.items.length) return false;

    cart.items.forEach(function (item, i) {
      var row = document.querySelector('.uf-cart-page__line[data-line="' + i + '"]');
      if (!row) return;

      var unitCell = row.querySelector('.uf-cart-page__cell-unit');
      var totalCell = row.querySelector('.uf-cart-page__cell-total');
      if (unitCell) unitCell.innerHTML = unitStackHtml(item, i);
      if (totalCell) totalCell.innerHTML = lineTotalStackHtml(item, i);

      if (typeof window.ufFormatM2LineQty === 'function') {
        var m2El = row.querySelector('[data-uf-cart-line-m2]');
        if (m2El && row.getAttribute('data-uf-show-cart-m2') === 'true') {
          var m2pp = parseFloat(String(row.getAttribute('data-uf-m2-per-pack') || '1').replace(',', '.'), 10);
          if (isNaN(m2pp) || m2pp <= 0) m2pp = 1;
          m2El.textContent = window.ufFormatM2LineQty(m2pp, item.quantity) + ' m² in pakken';
          var packEl = row.querySelector('.uf-cart-page__pack-unit');
          if (packEl) {
            packEl.textContent =
              window.UfRoomState && typeof window.UfRoomState.packWord === 'function'
                ? window.UfRoomState.packWord(item.quantity)
                : item.quantity === 1
                  ? 'pak'
                  : 'pakken';
          }
        }
      }
    });

    updateGrandTotal(cart);
    updateSavingsBanner(cart);

    if (typeof window.ufNormalizeCartMoneyDom === 'function') {
      var page = document.querySelector('.uf-cart-page');
      if (page) window.ufNormalizeCartMoneyDom(page);
    }

    if (typeof window.Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
      try {
        var cookieCurrency = Currency.cookie.read();
        var shopCurrency =
          (document.getElementById('storecurrencygeneral') &&
            document.getElementById('storecurrencygeneral').textContent) ||
          '';
        if (shopCurrency && cookieCurrency) Currency.convertAll(shopCurrency, cookieCurrency);
      } catch (e) {
        /* ignore */
      }
    }

    return true;
  }

  function ufCartRefreshAfterDiscount(cart) {
    if (!cart) return;
    if (document.querySelector('.uf-cart-page') && ufCartPageUpdatePrices(cart)) return;
    if (typeof jQuery !== 'undefined') {
      jQuery(document.body).trigger('afterCartLoad.ajaxCart', [cart]);
    }
  }

  window.ufCartPageUpdatePrices = ufCartPageUpdatePrices;
  window.ufCartRefreshAfterDiscount = ufCartRefreshAfterDiscount;

  document.addEventListener('uf-cart-page-prices-update', function (evt) {
    if (evt.detail && evt.detail.cart) ufCartPageUpdatePrices(evt.detail.cart);
  });
})();
